import { useEffect } from 'react'
import { type Websocket, WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseConversation } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventConversationStateChanged = () => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handle = (data: IResponseConversation) => {
    conversationStore.updateItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationStateChanged, handle), [])
}

interface IConversationState {
  id: number
  locked: boolean
  isLockPaused: boolean
}

export const subscribeConversationStateChange = (
  websocket: Websocket,
  callback: (state: IConversationState) => void
) =>
  websocket.on(WebsocketEvent.ConversationStateChanged, (conversation) => {
    const id = conversation.id
    const locked = conversation.is_locked
    const isLockPaused = conversation.is_lock_paused

    if (locked !== null && locked !== undefined) callback({ id, locked, isLockPaused })
  })
